import { Action } from '@ngrx/store';
import { ActionTypes } from '../../../core/models/actionTypes';
import { Meeting } from '../interfaces/meeting.interface';

export const NewMeeting = (meeting: Meeting) => {
  return <Action>{ type: ActionTypes.Meeting, payload: meeting };
};
